import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDateToTacho'
})
export class ExtractDateToTachoPipe implements PipeTransform {

  transform(value: string, args: string[]) : string {
    return value.slice(0,value.indexOf(" "));
  }

}
